var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customization_item"},[_c('div',{staticClass:"am_box",on:{"click":_vm.toCustomization}},[_c('div',{staticClass:"item_img"})])])}
var staticRenderFns = []

export { render, staticRenderFns }